import { EXPERIMENTS_SCOPE } from '../../config/constants';
import Experiments from '@wix/wix-experiments';
import axios from 'axios';
import querystring from 'querystring';
import {getAlbumData} from '../../services/albumsApi';

function getLocale({ wixCodeApi }) {
  return wixCodeApi.window.locale || 'en';
}

async function getExperimentsByScope(scope) {
  const experiments = new Experiments({
    scope,
  });
  await experiments.ready();
  return experiments.all();
}

async function getGalleryData({metaSiteId, pageUrl}) {
  const qsObj = (pageUrl && querystring.decode(pageUrl.split('?')[1])) || {};
  const setId = qsObj.setId;
  const gallerySettings = qsObj.gallerySettings;

  const data = await (getAlbumData({ metaSiteId, setId }))
  if (data) {
    data.gallerySettings = gallerySettings && parseInt(gallerySettings);
  }
  return data;
}

export async function createAppController(controllerConfig) {
  const { appParams, setProps, platformAPIs } = controllerConfig;
  console.log({ controllerConfig })
  const locale = getLocale(controllerConfig);
  const experiments = await getExperimentsByScope(EXPERIMENTS_SCOPE);
  const galleryData = platformAPIs && platformAPIs.bi.metaSiteId ? await getGalleryData(platformAPIs.bi) : null;
  const {metaSiteId} = (controllerConfig.wixCodeApi.location && controllerConfig.wixCodeApi.location.query) || {}
  return {
    async pageReady() {
      setProps({
        name: 'World',
        cssBaseUrl: appParams.baseUrls.staticsBaseUrl,
        locale,
        experiments,
        galleryData,
        metaSiteId
      });
    },
  };
}
